if (!customElements.get('image-content-card')) {
  class ImageContentCard extends HTMLElement {
    constructor() {
      super();
      this.tilt = this.querySelector('.image-content-card__tilt');
      this.bg = this.querySelector('.image-content-card__background');
      this.canvas = null;
      this.ctx = null;
      this.ripples = [];
      this.animating = false;
      this.setupCanvas();
      this.setupEventListeners();
    }

    setupCanvas() {
      if (!this.bg) return;
      this.canvas = document.createElement('canvas');
      this.canvas.classList.add('image-content-card__canvas');
      this.bg.appendChild(this.canvas);
      this.ctx = this.canvas.getContext('2d');
      this.resizeCanvas();
      window.addEventListener('resize', () => this.resizeCanvas());
    }

    resizeCanvas() {
      if (!this.canvas || !this.bg) return;
      const rect = this.bg.getBoundingClientRect();
      this.canvas.width = rect.width;
      this.canvas.height = rect.height;
    }

    addRipple(x, y) {
      this.ripples.push({
        x, y,
        radius: 0,
        maxRadius: Math.max(this.canvas.width, this.canvas.height) * 0.6,
        opacity: 0.35,
        speed: 3
      });
      if (!this.animating) {
        this.animating = true;
        this.animateRipples();
      }
    }

    animateRipples() {
      if (!this.ctx || !this.canvas) return;
      this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

      this.ripples = this.ripples.filter(r => r.opacity > 0.01);

      this.ripples.forEach(r => {
        r.radius += r.speed;
        r.opacity *= 0.97;

        this.ctx.beginPath();
        this.ctx.arc(r.x, r.y, r.radius, 0, Math.PI * 2);
        this.ctx.strokeStyle = `rgba(180, 155, 20, ${r.opacity})`;
        this.ctx.lineWidth = 2;
        this.ctx.stroke();

        // Inner glow ring
        this.ctx.beginPath();
        this.ctx.arc(r.x, r.y, r.radius * 0.7, 0, Math.PI * 2);
        this.ctx.strokeStyle = `rgba(215, 185, 35, ${r.opacity * 0.5})`;
        this.ctx.lineWidth = 1;
        this.ctx.stroke();
      });

      if (this.ripples.length > 0) {
        requestAnimationFrame(() => this.animateRipples());
      } else {
        this.animating = false;
      }
    }

    setupEventListeners() {
      if (!this.tilt) return;

      let rippleTimer = null;

      // Mouse enter
      this.addEventListener('mouseenter', () => {
        this.tilt.style.transition = 'transform 0.1s ease';
      });

      // Mouse move — 3D tilt + background spotlight + periodic ripples
      this.addEventListener('mousemove', (e) => {
        const rect = this.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const centerX = rect.width / 2;
        const centerY = rect.height / 2;

        // 3D tilt
        const rotateX = -((y - centerY) / (rect.height / 2)) * 12;
        const rotateY = ((x - centerX) / (rect.width / 2)) * 12;
        this.tilt.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;

        // Update spotlight gradient position on background
        if (this.bg) {
          const bgRect = this.bg.getBoundingClientRect();
          const bx = e.clientX - bgRect.left;
          const by = e.clientY - bgRect.top;
          const xPct = (bx / bgRect.width) * 100;
          const yPct = (by / bgRect.height) * 100;
          this.bg.style.backgroundImage = `radial-gradient(circle at ${xPct}% ${yPct}%, rgba(190, 160, 20, 0.7) 0%, transparent 60%)`;
        }

        // Auto-ripple every 300ms while moving
        if (this.canvas && !rippleTimer) {
          rippleTimer = setTimeout(() => {
            const bgRect = this.bg.getBoundingClientRect();
            this.addRipple(e.clientX - bgRect.left, e.clientY - bgRect.top);
            rippleTimer = null;
          }, 300);
        }
      });

      // Click for instant ripple
      this.addEventListener('click', (e) => {
        if (!this.canvas || !this.bg) return;
        const bgRect = this.bg.getBoundingClientRect();
        this.addRipple(e.clientX - bgRect.left, e.clientY - bgRect.top);
      });

      // Mouse leave — reset everything
      this.addEventListener('mouseleave', () => {
        this.tilt.style.transition = 'transform 0.5s ease-out';
        this.tilt.style.transform = 'perspective(1000px) rotateX(0deg) rotateY(0deg)';
        if (this.bg) {
          this.bg.style.backgroundImage = 'none';
        }
        if (rippleTimer) {
          clearTimeout(rippleTimer);
          rippleTimer = null;
        }
      });
    }
  }

  customElements.define('image-content-card', ImageContentCard);
}
